import { useState } from 'react';
import Cookies from 'js-cookie';
const Login = ({ setForgotPass }) => {
  // State to hold the form inputs
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent page refresh on form submission

    setLoading(true);
    setError(null); // Reset global error state
    setSuccess(null);
    setFieldErrors({}); // Reset field-specific error states

    try {
      // Create FormData and append the fields
      const formDataToSend = new FormData();
      formDataToSend.append('username', username);
      formDataToSend.append('password', password);
      formDataToSend.append('endpoint', 'user/login');
      const response = await fetch('/api/form/handler', {
        method: 'POST',
        body: formDataToSend, // Send FormData
      });
      // Parse response once
      const responseData = await response.json();
      if (!response.ok) {
        setSuccess();
        if (response.status === 422) {
          const newFieldErrors = {};
          for (let field in responseData.errors) {
            if (responseData.errors.hasOwnProperty(field)) {
              newFieldErrors[field] = responseData.errors[field][0];
            }
          }
          setFieldErrors(newFieldErrors);
        } else {
          throw new Error(responseData.message || 'Login failed. Please check your credentials.');
        }
        return;
      }
      const { message, token, user } = responseData.data;
      setSuccess(responseData.message);
      setError();
      // Save the token and user info in localStorage or cookies

      localStorage.setItem('user', JSON.stringify(user));
      // Save the token and user info in cookies
      Cookies.set('token', token, { expires: 7 }); // Set token cookie with 7 days expiration
      Cookies.set('user', JSON.stringify(user), { expires: 7 }); // Set user cookie with 7 days expiration
      setUsername(null);
      setPassword(null);
      // Reload the page after 2 seconds
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      // Redirect to dashboard or home page
      // router.push('/dashboard'); // Change this to the route you want to redirect to


    } catch (error) {
    
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h2 className="text-white text-[24px] lg:text-[2vw]">Login</h2>
      <div onSubmit={handleSubmit}> {/* Changed form tag to div */}
        <div>
          <label className="text-[13px] text-[#a3a3a3] text-start block mb-2">
            Username
          </label>
          <input
            type="text"
            className="border border-[rgba(0,0,0,0.5)] p-3 lg:p-[0.5vw] w-full text-[16px] lg:text-[1.2vw] text-black !cursor-text"
            value={username} // Bind value to state
            onChange={(e) => setUsername(e.target.value)} // Update state on change
            required // Make field required
          />
          {fieldErrors.username && <label className="text-red">{fieldErrors.username}</label>}
        </div>
        <div>
          <label className="text-[13px] text-[#a3a3a3] text-start block mb-2">
            Password
          </label>
          <input
            type="password"
            className="border border-[rgba(0,0,0,0.5)] p-3 lg:p-[0.5vw] w-full text-[16px] lg:text-[1.2vw] text-black !cursor-text"
            value={password} // Bind value to state
            onChange={(e) => setPassword(e.target.value)} // Update state on change
            required // Make field required
          />
          {fieldErrors.password && <label className="text-red">{fieldErrors.password}</label>}
        </div>



        <div className="pt-2 mb-2 flex justify-between items-center gap-4">
          <button
            type="button" // Change button type to "button" to prevent default form submit behavior
            onClick={handleSubmit} // Call handleSubmit directly on click
            className="border-none bg-[#a3a3a3] text-black py-2 px-5 font-semibold !cursor-pointer hover:bg-white"
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Submit'} {/* Show loading state */}
          </button>


          <div className="leading-normal text-[#a3a3a3] table">
            Did you forget your password?{" "}
            <span
              className="hover:text-white !cursor-pointer"
              onClick={() => setForgotPass(true)}
            >
              Click Here
            </span>
          </div>

        </div>
        {error && <div className="text-red	">{error}</div>} {/* Display error message */}
        {success && <div className="text-green	">{success}</div>} {/* Display success message */}
      </div> {/* Closed the div here */}
    </>
  );
};

export default Login;
